import { z } from 'zod'

const SingleLocationSchema = z.object({
  coordinates: z.tuple([z.number(), z.number()]),
  type: z.string(),
})

const TrackLocationSchema = z.object({
  coordinates: z.array(z.tuple([z.number(), z.number()])),
  type: z.literal('LineString'),
})

export const DeviceSchema = z.object({
  imei: z.string().min(1),
  name: z.string().min(0),
  last_known_location: SingleLocationSchema.nullable().optional(),
})

export type Devices = z.infer<typeof DeviceSchema>

export const TrackDeviceSchema = z.object({
  device: z.string().min(1),
  track: TrackLocationSchema.nullable(),
})

export type TrackDevice = z.infer<typeof TrackDeviceSchema>

export const BoatStopSchema = z.object({
  stop_id: z.number(),
  boat_id: z.number(),
  start_time: z.string(),
  end_time: z.string().nullable(),
  location: z.object({
    type: z.literal('Point'),
    coordinates: z.array(z.number()),
  }),
  grid_location: z.object({
    type: z.literal('Point'),
    coordinates: z.array(z.number()),
  }),
})

export type BoatStop = z.infer<typeof BoatStopSchema>

export const BoatStopsResponseSchema = z.object({
  boat_id: z.number(),
  stops: z.array(BoatStopSchema),
})

export type BoatStopsResponse = z.infer<typeof BoatStopsResponseSchema>
